module.exports = __webpack_public_path__ + "img/hp-h1.2f943865.svg";